export default __webpack_public_path__ + "static/media/SEC3030.34I-41289_-24632_0.4e8b3f43.jpg";